function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import { Button, Checkbox, FadeTransition, ItemList, ThemeExport } from '@deephaven/components';
import { dhSortAlphaDown, dhSortAlphaUp } from '@deephaven/icons';
import { TableUtils } from '@deephaven/jsapi-utils';
import { filterValidColumns } from "./AggregationUtils.js";
import "./AggregationEdit.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SortType = /*#__PURE__*/function (SortType) {
  SortType[SortType["NONE"] = 0] = "NONE";
  SortType[SortType["ASCENDING"] = 1] = "ASCENDING";
  SortType[SortType["DESCENDING"] = 2] = "DESCENDING";
  return SortType;
}(SortType || {});
var DEFAULT_ROW_HEIGHT = 30;
function AggregationEdit(_ref) {
  var aggregation = _ref.aggregation,
    columns = _ref.columns,
    onChange = _ref.onChange;
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    top = _useState2[0],
    setTop = _useState2[1];
  var _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    bottom = _useState4[0],
    setBottom = _useState4[1];
  var _useState5 = useState(SortType.NONE),
    _useState6 = _slicedToArray(_useState5, 2),
    sort = _useState6[0],
    setSort = _useState6[1];
  var invert = aggregation.invert,
    selected = aggregation.selected;
  var list = useRef(null);
  var isSelected = useCallback(name => selected.includes(name) ? !invert : invert, [invert, selected]);
  var validColumns = useMemo(() => {
    var filteredColumns = filterValidColumns(columns, aggregation.operation);
    if (sort !== SortType.NONE) {
      filteredColumns = TableUtils.sortColumns(filteredColumns, sort === SortType.ASCENDING);
    }
    return filteredColumns;
  }, [columns, aggregation.operation, sort]);
  var items = useMemo(() => top >= 0 ? validColumns.slice(top, bottom + 1).map(c => ({
    value: c.name,
    displayValue: c.name,
    isSelected: isSelected(c.name)
  })) : [], [validColumns, isSelected, bottom, top]);
  var handleSelect = useCallback(itemIndex => {
    var name = validColumns[itemIndex].name;
    var selectedIndex = selected.indexOf(name);
    var newSelected = [...selected];
    var newInvert = invert;
    if (selectedIndex >= 0) {
      newSelected.splice(selectedIndex, 1);
    } else {
      newSelected.push(name);
      if (newSelected.length === validColumns.length) {
        // Every item is either selected or deselected, flip the inversion bit
        newSelected = [];
        newInvert = !invert;
      }
    }
    onChange(_objectSpread(_objectSpread({}, aggregation), {}, {
      selected: newSelected,
      invert: newInvert
    }));
  }, [aggregation, invert, validColumns, selected, onChange]);
  var handleReset = useCallback(() => {
    setSort(SortType.NONE);
    onChange(_objectSpread(_objectSpread({}, aggregation), {}, {
      selected: [],
      invert: true
    }));
  }, [aggregation, onChange]);
  var handleViewportChange = useCallback((newTop, newBottom) => {
    setTop(newTop);
    setBottom(newBottom);
  }, [setTop, setBottom]);
  var toggleAll = useCallback(() => {
    if (selected.length === 0) {
      onChange(_objectSpread(_objectSpread({}, aggregation), {}, {
        invert: !invert
      }));
    } else {
      onChange(_objectSpread(_objectSpread({}, aggregation), {}, {
        selected: [],
        invert: true
      }));
    }
  }, [aggregation, invert, onChange, selected]);
  var checked = selected.length === 0 ? invert : null;
  var isModified = selected.length !== 0 || !invert || sort !== SortType.NONE;
  return /*#__PURE__*/_jsxs("div", {
    role: "menu",
    className: "aggregation-edit",
    children: [/*#__PURE__*/_jsx("div", {
      className: "top-menu",
      children: /*#__PURE__*/_jsxs("div", {
        className: "form-inline",
        children: [/*#__PURE__*/_jsx(Checkbox, {
          checked: checked,
          onChange: toggleAll,
          children: "Toggle All"
        }), /*#__PURE__*/_jsx("div", {
          className: "spacer"
        }), /*#__PURE__*/_jsx(FadeTransition, {
          in: isModified,
          timeout: ThemeExport.transitionSlowMs,
          mountOnEnter: true,
          unmountOnExit: true,
          children: /*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            className: "btn-reset",
            onClick: handleReset,
            children: "Reset"
          })
        }), /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: classNames({
            active: sort === SortType.ASCENDING
          }),
          icon: dhSortAlphaDown,
          tooltip: "Sort ascending",
          onClick: () => setSort(SortType.ASCENDING)
        }), /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: classNames({
            active: sort === SortType.DESCENDING
          }),
          icon: dhSortAlphaUp,
          tooltip: "Sort descending",
          onClick: () => setSort(SortType.DESCENDING)
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "aggregation-edit-item-list",
      children: /*#__PURE__*/_jsx(ItemList, {
        itemCount: validColumns.length,
        items: items,
        offset: top,
        renderItem: _ref2 => {
          var item = _ref2.item;
          return /*#__PURE__*/_jsx(Checkbox, {
            checked: isSelected(item.value),
            children: item.displayValue
          });
        },
        onSelect: handleSelect,
        onViewportChange: handleViewportChange,
        rowHeight: DEFAULT_ROW_HEIGHT,
        focusSelector: "input",
        ref: list
      })
    })]
  });
}
export default AggregationEdit;
//# sourceMappingURL=AggregationEdit.js.map